import React                        from 'react';
import { Observe }                  from 'rewire-core';
import {
  WithStyle,
  FormView,
  IEditorField,
}                                   from 'rewire-ui';
import { Theme }                    from '@material-ui/core/styles';
import DraggableResizableDialog     from '../ui/DraggableResizableDialog';
import AddValidationRuleDialogModel from './AddValidationRuleDialogModel';
import { withStyles }               from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IAddValidationRuleDialogProps {
  model: AddValidationRuleDialogModel;
}

type AddValidationRuleDialogProps = WithStyle<ReturnType<typeof styles>, IAddValidationRuleDialogProps>;

class AddValidationRuleDialog extends React.PureComponent<AddValidationRuleDialogProps> {
  constructor(props: AddValidationRuleDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    this.props.model.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={this.props.model.form} onSubmit={this.props.model.actionFn('add Validation Rule')}>
        {this.props.model.form.fields.map((field: IEditorField) =>
          <div key={field.name} className={'content'}>
            <field.Editor />
          </div>
        )}
     </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: this.props.model}} DraggableResizableBoxProps={{minWidth: '315px', minHeight: '213px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddValidationRuleDialogProps>(styles, AddValidationRuleDialog);
